import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";
import { asIcon } from "simplydo/react/ui/icon";

import { StyledDropdownHeader } from "./Dropdown.styles";
import type { DropdownHeaderProps } from "./Dropdown.types";

const DropdownHeaderComponent = (props: DropdownHeaderProps): ReactElement => {
  const { children, className, icon, style } = props;

  return (
    <StyledDropdownHeader className={cx(className)} style={style}>
      {asIcon(icon)}
      {children}
    </StyledDropdownHeader>
  );
};

export const DropdownHeader = styled(DropdownHeaderComponent)``;
